import React from "react";
import { ForfeitureSummaryContainer } from "../../../containers";

const ForfeitureSummary = (props) => {
  return <ForfeitureSummaryContainer {...props} />;
};

export default ForfeitureSummary;
